import {
  Avatar,
  SkeletonBlock,
  SkeletonText,
  Text,
} from "@zapier/design-system";
import { ownerAtomFamily_SUSPENDS } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

import styles from "./AvatarWithName.module.css";
import { Suspense } from "react";

type Props = {
  ownerId: number | null;
};

const AVATAR_SIZE = "small"; // If you change this, make sure to update loadingAvatar class in avatarWithName.module.css
const AVATAR_SIZE_PX = `24px`;

export function AvatarWithName({ ownerId }: Props) {
  if (!ownerId) {
    return <AvatarWithNameLoading />;
  }
  return (
    <Suspense fallback={<AvatarWithNameLoading />}>
      <AvatarWithNameInner ownerId={ownerId} />
    </Suspense>
  );
}

function AvatarWithNameInner({ ownerId }: Props) {
  const owner = useAtomValue(ownerAtomFamily_SUSPENDS(ownerId));
  const fullName = owner ? owner.full_name : "";
  return (
    <div className={styles.avatarWithNameWrapper}>
      <Avatar name={fullName} url={owner?.photo_url} size={AVATAR_SIZE} />
      <div data-testid="zapOwner">
        <Text type="SmallPrint1">{"Owned by "}</Text>
        <Text type="SmallPrint4">{fullName}</Text>
      </div>
    </div>
  );
}

function AvatarWithNameLoading() {
  return (
    <div className={styles.avatarWithNameWrapper}>
      <div className={styles.loadingAvatar}>
        <SkeletonBlock
          borderRadius="medium"
          height={AVATAR_SIZE_PX}
          width={AVATAR_SIZE_PX}
        />
      </div>
      <div className={styles.skeletonTextWrapper}>
        <SkeletonText lines={1} width="100%" />
      </div>
    </div>
  );
}

export default AvatarWithName;
